import React from 'react';
import styled from 'styled-components';
import { DateTime } from 'luxon';

const Title = styled.div`
  padding: 5px;
  font-size: 15px;
`;

const Date = styled.div`
  padding: 5px;
  font-size: 12px;
`;

export const ReportSelect = ({ report }) => {
  
  return (
    <React.Fragment>
      <Title>{report.resolvedTemplate.title}</Title>
      <Date>{DateTime.fromSQL(report.created).toFormat('dd LLL - hh:mm') + (report.resolvedSchedule === null? ' (Manual)' : '')}</Date>
    </React.Fragment>
  )
}

const StyledReportSelectOverlay = styled.div`
  width: 300px;
  height: 400px;
  position: absolute;
  background: #FFF;
  filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.25));
`;

export const ReportSelectOverlay = () => {
  
  return (
    <StyledReportSelectOverlay>
      something
    </StyledReportSelectOverlay>
  )
}